import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LabelText } from '@glu/form-components';
import { withStyles, withTheme } from '@glu/theming';
import SchedulerContext from '../SchedulerContext';
import styles from './StyledSelect.styles';
import '../themeDefaults';

const StyledSelect = ({
  classes, htmlId, dataQa, options, value, labelText, screenReaderLabel, onChange
}) => {
  const {
    disabled
  } = useContext(SchedulerContext);

  return (
    <label htmlFor={htmlId} className={classes.label}>
      <LabelText
        label={labelText}
        screenReaderLabel={screenReaderLabel}
      />
      <select
        id={`${htmlId}-styled-select`}
        name={`${htmlId}-styled-select`}
        data-qa={dataQa}
        className={classes.styled}
        value={value}
        disabled={disabled}
        onChange={onChange}
      >
        {options.map((opt) => (
          <option
            key={opt.value}
            value={opt.value}
          >
            {opt.label}
          </option>
        ))}
      </select>
    </label>
  );
};

StyledSelect.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  labelText: PropTypes.string.isRequired,
  screenReaderLabel: PropTypes.bool,
  htmlId: PropTypes.string.isRequired,
  dataQa: PropTypes.string.isRequired,
  options: PropTypes.instanceOf(Array).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired
};

StyledSelect.defaultProps = {
  screenReaderLabel: false
};

export default withTheme(withStyles(styles)(StyledSelect));
